import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import useDownloader from "react-use-downloader";

import SlideShow from "./slideShow/SlideShow";
import { downloadCardAttachment } from "../../../../../services/apiCards";
import { handleDownloadAttachment as downloadAttachments } from "../../../../../utils/downloadAttachments";
import { getResponseData } from "../../../../../reactQuery/response";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default React.memo( function SlideshowPopUp({
  slideImages,
  attachmentId,
  showAttachmentSlideShow,
  setShowAttachmentSlideShow,
}) {
  const { download } = useDownloader();

  const handleDownloadAttachment = (attachmentId) => {
    const getResponse = downloadCardAttachment(attachmentId);

    getResponse
      .then((res) => {
        const responseData = getResponseData(res, {});
        const filename =
          responseData?.attachment_name ?? responseData?.filename;
        const fileUrl = responseData?.url;

        if (filename && fileUrl) {
          // Extract the file extension from the URL
          const fileExtension = fileUrl.split(".").pop();

          // Append the extension to the filename if it's not already there
          const completeFilename = filename.endsWith(`.${fileExtension}`)
            ? filename
            : `${filename}.${fileExtension}`;

          // download(`${getUrl}/${fileUrl}`, completeFilename);
          downloadAttachments(fileUrl, completeFilename, download);
        } else {
          console.error("Error: Filename or file URL is missing.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
 
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={() => setShowAttachmentSlideShow(false)}
        aria-labelledby="customized-dialog-title"
        open={showAttachmentSlideShow}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          "& .MuiDialog-container": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxWidth: "1180px",
            "& .MuiPaper-root": {
              width: "100%",
              borderRadius: "12px",
              margin: "15px",
              maxWidth: "1180px",
            },
          },
        }}>
        <IconButton
          aria-label="close"
          onClick={(e) => {
            setShowAttachmentSlideShow(false);
          }}
         className="slideshow-close-icon"
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          {attachmentId && (
            <SlideShow
              slideImages={slideImages}
              attachmentId={attachmentId}
              handleDownloadAttachment={handleDownloadAttachment}
            />
          )}
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
})
